import { useEffect, useState } from 'react';
import apiFetch from '../utils/apiFetch';

/**
 * 对话弹窗打开时拉取该队员的服务端对话历史（入站 tracker_messages + 外发 tracker_commands）。
 * historyEpoch 递增时强制重拉（结束任务清缓存后）。
 */
export default function useMemberMessageHistory(open, deviceUniqueId, historyEpoch = 0) {
  const [history, setHistory] = useState([]);

  useEffect(() => {
    if (!open || !deviceUniqueId) {
      setHistory([]);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await apiFetch(`/api/tracker/messages/history?device_unique_id=${encodeURIComponent(deviceUniqueId)}&limit=80`);
        const data = await res.json().catch(() => ({}));
        if (!cancelled && res.ok && data.success && Array.isArray(data.messages)) {
          setHistory(data.messages);
        } else if (!cancelled) {
          setHistory([]);
        }
      } catch (_e) {
        if (!cancelled) setHistory([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [open, deviceUniqueId, historyEpoch]);

  return history;
}
